import React, { Fragment, useState } from "react";
import IIReceiptVoucherForm from "./IRV-form";
import {
  Avatar,
  colors,
  Container,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import { uri } from "../../../../../help/Api";
import TotalCard from "../../../../../components/TotalCard";
import ExternalFormSub from "../components/External-form-sub";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import { useStylesHed } from "../../../../../St/comps/UseStyle";
import toast from "react-hot-toast";
import useFormDataCRUD from "../../../../../components/Hooks/useEDSCURD";
import IReceiptAPI from "../../../../../api/IReceipt";
import {
  defaultValues,
  getEndDept,
  ReFormatingData,
} from "../../../../../services/InernalVoucher-service";
import axios from "axios";
import { sto } from "../../../../../Context/InshData";
import IReceiptVoucherAppBar from "./IReceiptVoucher-AppBar";
import { useTranslation } from "react-i18next";
import { GetIndexFromIdOptions, isMobileDevice, useStylesSand } from "../external-exchange-voucher/EExchangeVoucher";

export default function IReceiptVoucher(props) {
  const { AutoOptions, fetchURL, prmis, isDialog, item, onClose,
    AutoOptionsB,
    branch,
    setBranch,
   } = props;
   const [branchT, setBranchT] = useState(sto.branchi);
   const [optionsStocks, setOptionsStocks] = useState(AutoOptions?.Stocks);

  const defaultV = isDialog
    ? ReFormatingData({ ...item, emp_id: item.cust_id }, AutoOptions)
    : {
        ...defaultValues,
        id: AutoOptions.other.lastid,
        emp:GetIndexFromIdOptions(sto.idi,AutoOptions.Users),
        stock: AutoOptions.Stocks[0],
        bank: AutoOptions.Banks[0],
        user: GetIndexFromIdOptions(sto.idi,AutoOptions.Users),
      };

  const {
    onChange,
    submit,
    update,
    remove,
    submitting,
    errorMessage,
    onShow,
    onEnd,
    object,
    formType,
    getRow
  } = useFormDataCRUD(
    IReceiptAPI.create,
    IReceiptAPI.update,
    IReceiptAPI.remove,
    undefined,
    defaultV,
    null,
    () => {
      if (isDialog) onClose(true);
      else fetchURL();
    },
    isDialog ? "edit" : "new",
    IReceiptAPI.GetRow,
  );

  const changAutoCustomers = async (newValue) => {
    let end_dept1 = "0.0";
    await axios
      .get(
        uri +
          `AccountReports/rptABalanceSum?branch=${-1}
                &&costCenter=${-1}
                &&acc_code=${newValue.code.toString()}`
      )
      .then((res) => {
        end_dept1 = res.data.end_Dept - res.data.end_Credit;
      })
      .catch((res) => {
        toast.error(t("fetch-customer-debt-failed"));
        console.log("erro", res.error);
      });

    let nObject = {
      ...object,
      acc_code: newValue,
      end_Dept: end_dept1,
      notes: t("payment-to-account") + " " + newValue.name,
    };

    onShow(nObject, formType);
  };

  const { t } = useTranslation(["translation", "forms"]);
  const classes = useStylesSand();
  const clashd = useStylesHed();
  const subTile = formType == "edit" ? t("edit") : t("new");
  return (
    <Fragment>
      <div className={isMobileDevice?classes.root2:classes.root} style={{ direction: "rtl" }}>
        <Grid item container className={clashd.rootHd}>
          <Grid item xs={12}>
            <Typography
              variant={"h5"}
              component="h3"
              style={{
                marginBlock: 10,
              }}
            >
              {subTile} {t("int-receipt")}
            </Typography>
          </Grid>
        </Grid>
        <Typography component="div" style={{ direction: "rtl" }}>
          <Grid container justifyContent="center" spacing={3}>
            <Grid item lg={9} md={8} sm={12}>
              <Container
                component={Paper}
                maxWidth={false}
                style={{
                  padding:isMobileDevice?"10px" :"30px",
                  borderTopColor: colors.grey[900],
                  borderTopWidth: "2px",
                  borderTopStyle: "solid",
                }}
              >
                <IIReceiptVoucherForm
                  {...{
                    ...props,
                    object,
                    formType,
                    changAutoCustomers,
                    onChange,
                    AutoOptionsB,
                    branch,
                    setBranch,
                    branchT,
                    optionsStocks,
                    isMobileDevice
                  }}
                />
              </Container>
            </Grid>
            <Grid item lg={3} md={4} sm={12}>
              <TotalCard
                {...{
                  className: classes.card,
                  title: t("forms:account-balance-to-date"),
                  value: getEndDept(object.end_Dept),
                }}
              />
              <br />
              <Container
                component={Paper}
                maxWidth={true}
                style={{
                  padding: "20px",
                  borderBottomWidth: "0px",
                }}
              >
                <Grid container justify="space-between">
                  <Grid item>
                    <Typography
                      style={{ paddingTop: "8px" }}
                      variant="h4"
                      component="h4"
                    >
                      {t("forms:check-data")}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Avatar className={classes.avatar}>
                      <AttachMoneyIcon className={classes.icon} />
                    </Avatar>
                  </Grid>
                </Grid>
                <Divider />
                <br />

                <ExternalFormSub
                  {...{
                    ...props,
                    object,
                    changAutoCustomers,
                    onChange,
                  }}
                />

                <br />
              </Container>
            </Grid>
          </Grid>
        </Typography>
      </div>
      <IReceiptVoucherAppBar
        {...{
          URL: IReceiptAPI.URL,
          ...props,
          prmis,
          onChange,
          submit,
          isDialog,
          onClose,
          update,
          defaultV,
          remove,
          submitting,
          errorMessage,
          onShow,
          onEnd,
          object,
          formType,
          getRow,
          AutoOptions,
          branch,
          branchT,
          setBranchT,
          AutoOptionsB,
          setOptionsStocks
        }}
      />
    </Fragment>
  );
}
